import React, { useState, useEffect } from 'react';
import mammoth from 'mammoth';
import PropTypes from 'prop-types';
import { ProgressBar } from 'mw-style-react';
import './PreviewDocx.scss';

function PreviewDocx({ file }) {
  const [docHtml, setDocHtml] = useState(null);

  const getFileHtml = () => {
    const req = new XMLHttpRequest();
    req.open('GET', file, true);
    req.responseType = 'arraybuffer';
    req.onreadystatechange = () => {
      if (req.readyState === 4 && req.status === 200) {
        mammoth
          .convertToHtml(
            { arrayBuffer: req.response },
            { includeDefaultStyleMap: true }
          )
          .then((result) => {
            setDocHtml(result.value);
          })
          .done();
      }
    };
    req.send();
  };

  useEffect(() => {
    getFileHtml();
  }, [file]);

  const preloader = (
    <div styleName="docx__loader">
      <ProgressBar type="circle" size="medium" />
    </div>
  );

  const docxContent = (
    <div
      styleName="docx__container"
      dangerouslySetInnerHTML={{
        __html: docHtml,
      }}
      onClick={(e) => e.stopPropagation()}
    />
  );

  return <div styleName="docx">{docHtml ? docxContent : preloader}</div>;
}

PreviewDocx.propTypes = {
  file: PropTypes.string.isRequired,
};

export default PreviewDocx;
